import { Pipe, PipeTransform } from '@angular/core'
import { LocalEPGProgram } from '../interfaces/local-epg'
import moment from 'moment'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'programTitle',
  standalone: true,
})
export class ProgramTitlePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(program: LocalEPGProgram | null | undefined, locale?: string): string {
    if (!program) {
      return ''
    }

    const currentLocale = locale || moment.locale()

    const currentTranslation = program.translations[currentLocale]
    if (currentTranslation?.title) {
      return currentTranslation.title
    }

    const defaultTranslation = program.translations[program.defaultTranslationCode]
    if (defaultTranslation?.title) {
      return defaultTranslation.title
    }

    const availableTranslations = Object.keys(program.translations)
    for (const langCode of availableTranslations) {
      const translation = program.translations[langCode]
      if (translation?.title) {
        return translation.title
      }
    }

    return this.translateService.instant('PAGES.IPG.NO_PROGRAM_INFO_SHORT')
  }
}
